import React, { Component } from "react";
import { shape, func, bool, string } from "prop-types";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import { Col } from "react-bootstrap";

import Notification from "pages/_components/Notification";
import { resizableRoute } from "pages/_components/Resizable";
import ProductDetail from "pages/_components/ProductDetail";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import Information from "pages/deposits/_components/Information";
import DetailHeadTitle from "pages/deposits/_components/DetailHeadTitle";
import PageLoading from "pages/_components/PageLoading";
import Hint from "pages/_components/hints/Hint";
import Container from "pages/_components/Container";
import ContextMenu from "pages/_components/ContextMenu";

import { selectors as depositsSelectors, actions as depositsActions } from "reducers/deposits";

class Details extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        deposit: shape({
            idProduct: string,
            currency: string,
        }).isRequired,
        rest: shape().isRequired,
        match: shape().isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        fetchingDownload: bool.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, ...rest } = this.props;

        dispatch(depositsActions.readDeposit(rest.match.params.id));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, deposit, match } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                prevProps.deposit?.idProduct !== deposit?.idProduct ||
                prevProps.match.params.id !== match.params.id)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["deposits"],
            titleKey: "activities.deposits.detail.title",
            goBackPath: "/deposits",
            rightContentMobile: this.depositDetailMobileShellRightElement(),
        });
    };

    depositDetailMobileShellRightElement = () => {
        const { deposit, dispatch, embeddedInV3Shell } = this.props;

        if (!embeddedInV3Shell || !deposit) {
            return null;
        }

        return (
            <ContextMenu
                isDesktop={false}
                color="white"
                items={[
                    {
                        label: "products.alias.edit.deposit",
                        onClick: () => dispatch(push(`/deposit/${deposit.idProduct}/setProductAlias`)),
                        icon: "Pencil",
                    },
                    {
                        label: "global.download",
                        onClick: this.handleClickDownload("pdf"),
                        icon: "SendDown",
                    },
                ]}
            />
        );
    };

    handleClick = () => {
        const { dispatch } = this.props;
        dispatch(depositsActions.toggleOptions());
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        dispatch(depositsActions.closeOptions());
        if (embeddedInV3Shell) {
            dispatch(push("/deposits"));
            return;
        }
        dispatch(goBack());
    };

    handleClickDownload = (format) => () => {
        const { dispatch, match } = this.props;
        dispatch(depositsActions.downloadDetail(match.params.id, format));
    };

    render() {
        const { deposit, isDesktop, dispatch, fetching, fetchingDownload, embeddedInV3Shell, ...rest } = this.props;

        return (
            <PageLoading loading={fetching}>
                {!fetching && deposit && (
                    <>
                        {!embeddedInV3Shell && <Notification scopeToShow="deposits/details" />}
                        <ProductDetail>
                            <ProductDetail.Head
                                onBack={this.handleBack}
                                dispatch={dispatch}
                                productId={rest.match.params.id}
                                renderDownload={() => {}}
                                title="activities.deposits.detail.title"
                                embeddedInV3Shell={embeddedInV3Shell}>
                                {isDesktop && <div />}
                                <DetailHeadTitle
                                    deposit={deposit}
                                    isDesktop={isDesktop}
                                    dispatch={dispatch}
                                    fetchingDownload={fetchingDownload}
                                    handleClickDownload={this.handleClickDownload}
                                    embeddedInV3Shell={embeddedInV3Shell}
                                />
                            </ProductDetail.Head>
                            <ProductDetail.Body isDesktop={isDesktop} moreFilters={false}>
                                <Information
                                    deposit={deposit}
                                    keyLabel="deposits.details.information"
                                    dispatch={dispatch}
                                />

                                <Container className="align-items-center flex-grow">
                                    <Col className="col col-12" lg={6} xl={6} sm={12} md={9}>
                                        <Hint
                                            idMessage="deposits.information.disclaimer.untransferable"
                                            styleImage={{
                                                marginTop: "1.2rem",
                                            }}
                                            classNameHintP="hint-font-size-small font-weight-normal"
                                            alwaysShowMessage
                                        />
                                    </Col>
                                </Container>
                            </ProductDetail.Body>
                        </ProductDetail>
                    </>
                )}
            </PageLoading>
        );
    }
}

const mapStateToProps = (state) => ({
    deposit: depositsSelectors.getSelectedDeposit(state),
    fetching: depositsSelectors.getFetching(state),
    fetchingDownload: depositsSelectors.getFetchingDownload(state),
});

export default connect(mapStateToProps)(resizableRoute(Details));
